import { Typography } from '@mui/material';
import Anchor from '../../foundation/Anchor';
import CustomBR from '../../foundation/CustomBR';
import DialogWithHeader from '../../foundation/DialogWithHeader';

type NoAvailableJobSlotsDialogProps = {
    open: boolean
    onClose: () => void
};

export const NoAvailableJobSlotsDialog = ({
    open,
    onClose,
}: NoAvailableJobSlotsDialogProps) => (
    <DialogWithHeader
        open={open}
        onClose={onClose}
        title="רכישת חבילת משרות">
        <>
            <CustomBR />
            <Typography>על מנת לפרסם משרות יש לרכוש חבילת משרות תחילה.</Typography>
            <CustomBR />
            <Anchor
                text="לרכישת חבילת משרות"
                blank
                href="/backoffice/employers/buy-promoted-jobs"
            />
            <CustomBR />
        </>
    </DialogWithHeader>
);
